import AnalyticsEventName from './analyticsEventName';
import track from './track';

const trackLogoutClick = () => {
    track(AnalyticsEventName.SIGNED_OUT);
};

const initTrackLogoutClick = () => {
    const logoutLinks = document.querySelectorAll<HTMLElement>('.action-logout');
    logoutLinks.forEach((logoutLink) => {
        if (typeof logoutLink.dataset.heapEventAdded !== 'undefined') {
            return;
        }
        // eslint-disable-next-line no-param-reassign
        logoutLink.dataset.heapEventAdded = '1';
        logoutLink.addEventListener('click', trackLogoutClick);
    });
};

export default initTrackLogoutClick;
